<ng-template #loading>
    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
</ng-template>

<div class="card">
    <p-accordion multiple="true" (activeIndexChange)="handleOnOpen($event)" #authAccordions>
        <p-accordionTab [(selected)]="activeState[0]">
            <ng-template #header>
                Add Authorizations
                <span *ngIf="employeeswithoutauths">(There are employees without authorizations)</span>
            </ng-template>
            <form [formGroup]="addModeFormGroup" #addModeForm="ngForm" id="addModeForm">
                <p-toolbar>
                    <div class="flex items-center mr-5">
                        <p-checkbox inputId="cbaddmode" #cbAddMode formControlName="addMode"
                            [disabled]="selected?.length > 0 || editing" ariaLabelledBy="labelAddMode"
                            [binary]="true"></p-checkbox>
                        <label for="cbaddmode" id="labelAddMode" class="ml-2">Add Mode</label>
                    </div>
                    <button class="mr-5" type="button" severity="primary" pButton pRipple #addPendingAuths
                        id="btnAddPendingAuths" [disabled]="
                        !isAddMode || pendingAuthsCount == 0
                    " aria-label="Add" label="Add {{ pendingAuthsCount }} Auths"></button>
                    <label for="cbaddmode" *ngIf="selected?.length > 0">
                        <button class="p-button-text p-button-secondary" (click)="selected = []" [disabled]="!selected?.length"
                            label="Clear selection to enable Add mode."></button>
                        Add mode disabled while items selected for
                        editing.
                    </label>
                    <label for="cbaddmode" *ngIf="false">Select display filters</label>
                    <label *ngIf="isAddMode" for="cbaddmode">
                        <span *ngIf="AuthAutomatedPI">
                            Payroll Item will be assigned based on task
                            labor type.
                        </span>
                        <span *ngIf="!AuthAutomatedPI">Employee's default payroll item will be
                            assigned, update as required.</span>
                    </label>
                </p-toolbar>
                <p-toolbar>
                    <button id="btnClearFilters" severity="info" type="button" pButton pRipple text
                        aria-label="Clear Filter" #clearFilters label="Clear" [disabled]="!isAddMode"></button>
                    <p-floatLabel variant="on">
                        <p-multiselect [virtualScroll]="true" [itemSize]="dropdownItemHeight"
                            *ngIf="userAuthTypes as items; else loading" [options]="items | orderBy: 'AuthType'"
                            [filter]="true" appendTo="body" selectedItemsLabel="{0} Type(s) requested."
                            formControlName="authType" styleClass="w-12rem"
                            [disabled]="!isAddMode"></p-multiselect>
                        <label for="float-dd">Auth Type</label>
                    </p-floatLabel>
                    <p-floatLabel variant="on">
                        <p-multiselect styleClass="w-12rem" [virtualScroll]="true" [itemSize]="dropdownItemHeight"
                            *ngIf="activeReports as items; else loading" [options]="items | orderBy: 'EmployeeName'"
                            optionLabel="EmployeeName" appendTo="body" [filter]="true"
                            selectedItemsLabel="{0} User(s) requested." formControlName="directReports"
                            dataKey="EmployeeListID" [disabled]="!isAddMode"></p-multiselect>
                        <label for="float-dd">Users</label>
                    </p-floatLabel>
                    <p-floatLabel variant="on">
                        <p-multiselect styleClass="w-16rem" [itemSize]="dropdownItemHeight"
                            *ngIf="activeTasks as items; else loading" [options]="items" appendTo="body" [filter]="true"
                            selectedItemsLabel="{0} Task(s) requested." formControlName="task" [disabled]="!isAddMode"></p-multiselect>
                        <label for="float-dd">Tasks</label>
                    </p-floatLabel>
                    <p-floatLabel variant="on">
                        <p-select styleClass="w-12rem" *ngIf="serviceItems as items; else loading"
                            [options]="items | orderBy: 'ServiceItem'" [virtualScroll]="true"
                            [itemSize]="dropdownItemHeight" formControlName="serviceItem" [filter]="true"
                            appendTo="body" [disabled]="!isAddMode"></p-select>
                        <label for="float-dd">Service Item</label>
                    </p-floatLabel>
                    <div class="flex items-center">
                        <p-checkbox binary="true" [formControl]="addModeFormGroup.controls['ShowSI']"
                            data-toggle="tooltip" data-placement="top" title="Show SI on TimeCard"
                            [disabled]="!isAddMode"></p-checkbox>
                        <label class="ml-2">Show SI on TimeCard</label>
                    </div>
                    <div class="flex items-center">
                        <p-checkbox binary="true" [formControl]="addModeFormGroup.controls['ShowPI']"
                            data-toggle="tooltip" data-placement="top" title="Show PI on TimeCard"
                            [disabled]="!isAddMode"></p-checkbox>
                        <label class="ml-2">Show PI on TimeCard</label>
                    </div>
                    <p-floatLabel variant="on">
                        <p-datepicker [monthNavigator]="true" [yearNavigator]="true" [yearRange]="
                            moment().add(-5, 'year').format('YYYY') +
                            ':' +
                            moment().add(5, 'year').format('YYYY')
                        " formControlName="EmployeeAuthStartDate" dataType="string" appendTo="body"
                            [inputStyle]="{ width: '7rem' }"></p-datepicker>
                        <label for="float-dd">Start Date</label>
                    </p-floatLabel>
                    <p-floatLabel variant="on">
                        <p-datepicker [monthNavigator]="true" [yearNavigator]="true" [yearRange]="
                            moment().add(-5, 'year').format('YYYY') +
                            ':' +
                            moment().add(5, 'year').format('YYYY')
                        " formControlName="EmployeeAuthEndDate" dataType="string" appendTo="body"
                            [inputStyle]="{ width: '7rem' }"></p-datepicker>
                        <label for="float-dd">End Date</label>
                    </p-floatLabel>
                </p-toolbar>
            </form>
            <div class="card">
                <div id="pendingAuthorizations" [hidden]="!pendingAuthsCount">
                    <p-table stripedRows [value]="pendingAuthorizations" #dtPendingAuthorizations
                        tableStyleClass="table p-datatable-full" [scrollable]="true" scrollDirection="both"
                        scrollHeight="10vh" [style]="{ 'max-width': '100%' }" id="dtPendingAuthorizations">
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="8" style="text-align: center">
                                    <div class="tabulator-placeholder">
                                        <span> No Data Available </span>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="loadingbody">
                            <tr>
                                <td colspan="17" style="text-align: center">
                                    <div>
                                        Loading...<i class="fa fa-spinner fa-spin"></i>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template #header let-item>
                            <tr>
                                <!-- AuthType -->
                                <th pSortableColumn="AuthTypeId">
                                    Type
                                    <p-sortIcon
                                        title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                </th>
                                <!-- EmployeeName -->
                                <th pSortableColumn="EmployeeName">
                                    User
                                    <p-sortIcon
                                        title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                        field="EmployeeName" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                </th>
                                <!-- Task -->
                                <th pSortableColumn="TaskLongName">
                                    Task
                                    <p-sortIcon
                                        title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                        ariaLabel="Activate to sort" field="TaskLongName"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                </th>
                                <!-- Payroll Item -->
                                <th pSortableColumn="PayrollItem">
                                    Payroll Item
                                    <p-sortIcon
                                        title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                        field="PayrollItem" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                </th>
                                <!-- Service Item -->
                                <th pSortableColumn="ServiceItem">
                                    Service Item
                                    <p-sortIcon
                                        title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                        ariaLabel="Activate to sort" field="ServiceItem"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                </th>
                                <!-- Show SI on TImeCard -->
                                <th pSortableColumn="ShowSI">
                                    Show SI
                                    <p-sortIcon
                                        title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                        field="ShowSI" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                </th>
                                <!-- Show PI on TImeCard -->
                                <th pSortableColumn="ShowPI">
                                    Show PI
                                    <p-sortIcon
                                        title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                        field="ShowPI" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                </th>
                                <!-- EmpAuthStartDate -->
                                <th pSortableColumn="EmpAuthStartDate">
                                    Start Date
                                    <p-sortIcon
                                        title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                        field="EmpAuthStartDate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                </th>
                                <!-- EmpAuthEndDate -->
                                <th pSortableColumn="EmpAuthEndDate">
                                    End Date
                                    <p-sortIcon
                                        title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                        field="EmpAuthEndDate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-item>
                            <tr>
                                <!-- AuthType -->
                                <td [attr.title]="item?.AuthType">
                                    {{ item?.AuthType }}
                                </td>
                                <!-- EmployeeName -->
                                <td>
                                    {{ item?.EmployeeName }}
                                </td>
                                <!-- Task -->
                                <td [attr.title]="item?.TaskLongName">
                                    {{ item?.TaskLongName }}
                                </td>
                                <!-- Payroll Item -->
                                <td [attr.title]="item?.PayrollItem">
                                    {{ item?.PayrollItem }}
                                </td>
                                <!-- Service Item -->
                                <td [attr.title]="item?.ServiceItem">
                                    {{ item?.ServiceItem }}
                                </td>
                                <!-- Show SI on TImeCard -->
                                <td>
                                    <i [ngClass]="{
                                        pi: true,
                                        'pi-check': addModeFormGroup.get('ShowSI')?.value,
                                        green: addModeFormGroup.get('ShowSI')?.value
                                    }"></i>
                                </td>
                                <!-- Show PI on TImeCard -->
                                <td>
                                    <i [ngClass]="{
                                        pi: true,
                                        'pi-check': addModeFormGroup.get('ShowPI')?.value,
                                        green: addModeFormGroup.get('ShowPI')?.value
                                    }"></i>
                                </td>
                                <!-- EmpAuthStartDate -->
                                <td>
                                    {{ moment(item?.EmpAuthStartDate).format('L') }}
                                </td>
                                <!-- EmpAuthEndDate -->
                                <td>
                                    {{ moment(item?.EmpAuthEndDate).format('L') }}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab [selected]="true" [disabled]="true" header="Authorizations">
            <div class="authorizations" id="tableAuthorizations">
                <p-toolbar>
                    <form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
                        <!-- <div class="flex items-center">
                            <p-checkbox #cbShowEndDate [disabled]="cbAddMode.checked" [(ngModel)]="showPastAuths"
                                (ngModelChange)="
                                        updateShowPastAuths(
                                            cbShowEndDate.checked
                                        )
                                    " [ngModelOptions]="{ standalone: true }" binary="true"></p-checkbox>
                            <label class="ml-2">Include Past Authorizations beginning with</label>
                        </div> -->
                        <p-floatLabel variant="on">
                            <p-select title="Include authorizations that ended in previous calendar years." formControlName="endDate" appendTo="body" styleClass="w-12rem"
                            [options]="yearOptions" [autoDisplayFirst]="false" [showClear]="true" (onClear)="onYearFilterClear()"></p-select>
                            <label for="float-dd">Past Authorizations</label>
                        </p-floatLabel>


                    </form>
                    <p-togglebutton class="ml-4" inputId="showhideDetails" [(ngModel)]="displayDetails"
                        [onLabel]="'Hide Details'" offLabel="Show Details"></p-togglebutton>
                    <p-togglebutton #showHolidays [onLabel]="'Hide Holidays'" offLabel="Show Holidays"
                        [(ngModel)]="displayHolidays" (onChange)="
                            onDisplayHolidaysChange(showHolidays.checked)
                        " *featureFlag="'hideHolidayAuths'"></p-togglebutton>
                    <button class="p-button-text p-button-secondary" #clearSelectionBtn [disabled]="!selected?.length">
                        Clear Selection
                    </button>
                    <span>
                        {{ selected?.length || 0 }}
                        rows selected.
                    </span>
                    <div>
                        <button [disabled]="!selected?.length" icon="pi pi-external-link" pButton pRipple
                            severity="primary" #updateMultipleAuths label="Multi-Update"
                            title="Update multiple authorizations"></button>
                    </div>
                    <button pButton type="button" severity="primary" aria-label="Copy" [disabled]="
                            !selected?.length || selected.some(hasErrorStatus)
                        " #copyAuths icon="fas fa-copy" label="Copy"></button>
                    <button #bulkDelete pButton type="button" class="p-button-danger" aria-label="Bulk Delete"
                        [disabled]="!selected?.length" icon="fas fa-trash-alt" label="Delete"></button>
                    <div>
                        <button [hidden]="true" icon="pi pi-refresh" pButton #refreshAuths label="Refresh"
                            title="Refresh display after authorization date changes"></button>
                    </div>
                    <div style="padding-left: 1em">
                        <button type="button" pButton pRipple icon="pi pi-download"
                            (click)="dtAuthorizations.exportCSV()" severity="primary" pTooltip="Download"
                            tooltipPosition="bottom"></button>
                        <!-- <p-splitButton
                            id="download-csv"
                            styleClass="p-button-secondary"
                            icon="pi pi-download"
                            pTooltip="Download"
                            [model]="this.downloadOptions"
                        ></p-splitButton> -->
                    </div>
                </p-toolbar>
                <p-table stripedRows id="dataTable" [value]="filteredItems" dataKey="EmpAuthID" #dataTable editMode="row"
                    [multiSortMeta]="[
                    { field: 'EmployeeName', order: 1 },
                    { field: 'TaskLongName', order: 2 },
                    { field: 'AuthTypeId', order: 3 },
                    { field: 'EmpAuthStartDate', order: 4 },
                    { field: 'EmpAuthEndDate', order: 5 }
                ]" sortMode="multiple" [scrollable]="true" scrollDirection="both" scrollHeight="55vh" [rows]="30"
                    [virtualScroll]="virtualScroll" [virtualRowHeight]="27" [(selection)]="selected"
                    (onRowSelect)="onRowSelect($event)" [columns]="cols">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="17" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loadingbody">
                        <tr>
                            <td colspan="17" style="text-align: center">
                                <div>
                                    Loading...<i class="fa fa-spinner fa-spin"></i>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template #header let-item>
                        <tr>
                            <!-- Edit -->
                            <th class="edit-cell"></th>
                            <!-- status-->
                            <th class="status-cell" pSortableColumn="Status.StatusCode">
                                <i class="pi pi-exclamation-circle" title="Status"></i>
                            </th>
                            <!-- Selection -->
                            <th class="select-cell">
                                <p-tableHeaderCheckbox
                                    *ngIf="!isAddMode && !editing"></p-tableHeaderCheckbox>
                            </th>
                            <!-- EmployeeName -->
                            <th pSortableColumn="EmployeeName">
                                User
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="EmployeeName" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="EmployeeListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiselect defaultLabel="Filter"
                                            maxSelectedLabels="1" selectedItemsLabel="{0} User(s) filtered."
                                            appendTo="body" [options]="directReportsFilterSelectItems" [filter]="true"
                                            styleClass="w-full" [ngModel]="value"
                                            (ngModelChange)="filter($event)">
                                        </p-multiselect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- Task -->
                            <th pSortableColumn="TaskLongName">
                                Task
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="TaskLongName" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="TaskListID" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiselect
                                            defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                            [options]="tasksFilterSelectItems" [filter]="true"
                                            styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)">
                                        </p-multiselect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- Service Item -->
                            <th pSortableColumn="SIListID">
                                Service Item
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="SIListID" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="SIListID" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiselect
                                            defaultLabel="Filter" maxSelectedLabels="1" appendTo="body" [options]="
                                        serviceItemsFilterSelectItems
                                    " [filter]="true" styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)"></p-multiselect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- Payroll Item -->
                            <th pSortableColumn="PIListID">
                                Payroll Item
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="PIListID" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="PIListID" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiselect
                                            defaultLabel="Filter" maxSelectedLabels="1" appendTo="body" [options]="
                                        payrollItemsFilterSelectItems
                                    " [filter]="true" styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)"></p-multiselect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- AuthType -->
                            <th pSortableColumn="AuthTypeId">
                                Type
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="AuthTypeId" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="AuthTypeId" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiselect
                                            defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                            [options]="userAuthTypes" [filter]="true" styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)"></p-multiselect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- EmpAuthStartDate -->
                            <th pSortableColumn="EmpAuthStartDate">
                                Start Date
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="EmpAuthStartDate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- EmpAuthEndDate -->
                            <th pSortableColumn="EmpAuthEndDate">
                                End Date
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="EmpAuthEndDate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- Show SI on TImeCard -->
                            <th pSortableColumn="ShowSI" *ngIf="displayDetails">
                                Show SI
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="ShowSI" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- Show PI on TImeCard -->
                            <th pSortableColumn="ShowPI" *ngIf="displayDetails">
                                Show PI
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="ShowPI" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- ModifiedDateTime -->
                            <th *ngIf="displayDetails" pSortableColumn="ModifiedDateTime">
                                Modified Date
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="ModifiedDateTime" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="ModifiedDateTime" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiselect defaultLabel="Filter" maxSelectedLabels="0"
                                            selectedItemsLabel="{0} items filtered." appendTo="body"
                                            [options]="modifiedDatesSelectItems" [filter]="true" styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)"></p-multiselect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- MaxHours -->
                            <th pSortableColumn="MaxHours">
                                Planned Hours
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="MaxHours" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- HoursWorked -->
                            <th pSortableColumn="HoursWorked">
                                Hours Worked
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="HoursWorked" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- ClassList -->
                            <th *ngIf="displayDetails && useClass" pSortableColumn="ClassListID">
                                Class
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="ClassListID" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="ClassListID" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiselect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                            [options]="classItemsFilterSelectItems" [filter]="true" styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)"></p-multiselect>
                                    </ng-template>
                                </p-columnFilter>

                            </th>
                            <!-- PremiumPayIndicator -->
                            <th *ngIf="displayDetails" pSortableColumn="PremiumPayIndicator">
                                Premium
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="PremiumPayIndicator" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- AuthDesc -->
                            <th *ngIf="displayDetails" pSortableColumn="AuthDesc">
                                Description
                                <p-sortIcon
                                    title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                    field="AuthDesc" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter type="text" matchMode="contains" field="AuthDesc" display="menu" class="ml-auto" />
                            </th>
                            <!-- Delete -->
                            <th class="delete-cell"></th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-item let-edit="editing" let-ri="rowIndex" let-rowData>
                        <tr [pSelectableRow]="item" [pEditableRow]="item" data-id="row-{{ item.EmpAuthID }}">
                            <!-- Edit -->
                            <td class="edit-cell">
                                <!-- for a new row -->
                                <button *ngIf="
                                        item?.EmpAuthID === -1 &&
                                        !edit &&
                                        !isAddMode
                                    " title="Add" pButton type="button" pInitEditableRow icon="pi pi-plus"
                                    class="p-button-rounded p-button-text p-button-success"
                                    (click)="onRowEditInit(item)"></button>
                                <button *ngIf="
                                        !edit &&
                                        (!editing?.EmpAuthID ||
                                            editing?.EmpAuthID ===
                                                item?.EmpAuthID) &&
                                        item.id !== 'add' &&
                                        selected?.length < 2
                                    " title="Edit" pButton type="button" pInitEditableRow icon="pi pi-pencil"
                                    class="p-button-rounded p-button-text" (click)="onRowEditInit(item)"
                                    title="Edit"></button>
                                <button *ngIf="edit" title="Save" pButton type="button" pSaveEditableRow
                                    icon="pi pi-check" class="p-button-rounded p-button-text p-button-success"
                                    (click)="onRowEditSave(item)"></button>
                                <button *ngIf="edit" title="Cancel" pButton type="button" pCancelEditableRow
                                    icon="pi pi-times" class="p-button-rounded p-button-text p-button-danger"
                                    (click)="onRowEditCancel(item)"></button>
                            </td>
                            <!-- Status-->
                            <td class="status-cell">
                                <div (click)="onStatusClick(item)" class="status-cell">
                                    <ef-status-icon [status]="item?.Status?.StatusCode"
                                        [message]="item?.Status?.Message"></ef-status-icon>
                                </div>
                            </td>
                            <!-- Selection -->
                            <td class="select-cell">
                                <p-tableCheckbox [value]="rowData"
                                    *ngIf="!isAddMode && !editing"></p-tableCheckbox>
                            </td>
                            <!-- EmployeeName -->
                            <td class="disabled">
                                <div>
                                    {{ item.EmployeeName }}
                                </div>
                            </td>
                            <!-- Task -->
                            <td class="disabled" [attr.title]="
                                (
                                    tasks
                                    | itemlookup: 'value':item?.TaskListID
                                )?.label
                            ">
                                {{
                                (
                                tasks
                                | itemlookup: 'value':item?.TaskListID
                                )?.label
                                }}
                            </td>
                            <!-- Service Item -->
                            <td [attr.title]="
                                (
                                    serviceItems
                                    | itemlookup: 'value':item?.SIListID
                                )?.label ?? item.SIListID
                            ">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-select styleClass="w-full" [ngClass]="{
                                            'ng-invalid': !item.SIListID
                                        }" [ngModelOptions]="{
                                            standalone: true
                                        }" [autoDisplayFirst]="false" appendTo="body" [options]="serviceItems"
                                            [(ngModel)]="item.SIListID"></p-select>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{
                                        (
                                        serviceItems
                                        | itemlookup
                                        : 'value'
                                        : item?.SIListID
                                        )?.label ?? item.SIListID
                                        }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- Payroll Item -->
                            <td [attr.title]="
                                (
                                    payrollItems
                                    | itemlookup: 'PIListID':item?.PIListID
                                )?.PayrollItem ?? item.PIListID
                            ">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-select styleClass="w-full" [ngClass]="{
                                            'ng-invalid': !item.PIListID
                                        }" [ngModelOptions]="{
                                            standalone: true
                                        }" [autoDisplayFirst]="false" appendTo="body"
                                            [options]="payrollItemsForAuth" [(ngModel)]="item.PIListID"></p-select>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{
                                        (
                                        payrollItems
                                        | itemlookup
                                        : 'PIListID'
                                        : item?.PIListID
                                        )?.PayrollItem ?? item.PIListID
                                        }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- AuthType -->
                            <td [attr.title]="
                                (
                                    userAuthTypes
                                    | itemlookup: 'value':item?.AuthTypeId
                                )?.title
                            ">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-select styleClass="w-full" [ngClass]="{
                                            'ng-invalid': !item.AuthTypeId
                                        }" [autoDisplayFirst]="false" appendTo="body" [options]="userAuthTypes"
                                            [(ngModel)]="item.AuthTypeId"></p-select>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{
                                        (
                                        userAuthTypes
                                        | itemlookup
                                        : 'value'
                                        : item?.AuthTypeId
                                        )?.label
                                        }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- EmpAuthStartDate -->
                            <td>
                                <p-cellEditor>
                                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                        <p-datepicker inputStyleClass="p-inputtext"
                                            [(ngModel)]="item.EmpAuthStartDate" appendTo="body"
                                            [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"
                                            [readonlyInput]="false" dateFormat="mm/dd/yy" [required]="true">
                                        </p-datepicker>
                                    </ng-template>
                                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                        {{
                                        moment(
                                        item?.EmpAuthStartDate
                                        ).isValid()
                                        ? moment(
                                        item?.EmpAuthStartDate
                                        ).format('MM/DD/YYYY')
                                        : ''
                                        }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{
                                        moment(
                                        item?.EmpAuthStartDate
                                        ).isValid()
                                        ? moment(
                                        item?.EmpAuthStartDate
                                        ).format('MM/DD/YYYY')
                                        : ''
                                        }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- EmpAuthEndDate -->
                            <td>
                                <p-cellEditor>
                                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                        <p-datepicker inputStyleClass="p-inputtext" [(ngModel)]="item.EmpAuthEndDate"
                                            appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                            yearRange="2000:2030" [readonlyInput]="false" dateFormat="mm/dd/yy"
                                            [required]="true">
                                        </p-datepicker>
                                    </ng-template>
                                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                        {{
                                        moment(
                                        item?.EmpAuthEndDate
                                        ).isValid()
                                        ? moment(
                                        item?.EmpAuthEndDate
                                        ).format('MM/DD/YYYY')
                                        : ''
                                        }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{
                                        moment(
                                        item?.EmpAuthEndDate
                                        ).isValid()
                                        ? moment(
                                        item?.EmpAuthEndDate
                                        ).format('MM/DD/YYYY')
                                        : ''
                                        }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- ShowSI -->
                            <td *ngIf="displayDetails">
                                <p-cellEditor>
                                    <ng-template pTemplate="input" *ngIf="!item.IsReadOnly">
                                        <p-checkbox binary="true" [(ngModel)]="item.ShowSI" [ngModelOptions]="{
                                            standalone: true
                                        }"></p-checkbox>
                                    </ng-template>
                                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                        <i [ngClass]="{
                                            pi: true,
                                            'pi-check': item?.ShowSI,
                                            green: item?.ShowSI
                                        }"></i>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <i [ngClass]="{
                                            pi: true,
                                            'pi-check': item?.ShowSI,
                                            green: item?.ShowSI
                                        }"></i>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- ShowPI -->
                            <td *ngIf="displayDetails">
                                <p-cellEditor>
                                    <ng-template pTemplate="input" *ngIf="!item.IsReadOnly">
                                        <p-checkbox binary="true" [(ngModel)]="item.ShowPI" [ngModelOptions]="{
                                            standalone: true
                                        }"></p-checkbox>
                                    </ng-template>
                                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                        <i [ngClass]="{
                                            pi: true,
                                            'pi-check': item?.ShowPI,
                                            green: item?.ShowPI
                                        }"></i>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <i [ngClass]="{
                                            pi: true,
                                            'pi-check': item?.ShowPI,
                                            green: item?.ShowPI
                                        }"></i>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- ModifiedDateTime -->
                            <td *ngIf="displayDetails" class="disabled">
                                {{
                                moment(item?.ModifiedDateTime).isValid()
                                ? moment(item?.ModifiedDateTime).format(
                                'MM/DD/YYYY'
                                )
                                : ''
                                }}
                            </td>
                            <!-- MaxHours -->
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input title="Max Hours" type="number" pInputText
                                            [(ngModel)]="item.MaxHours" [ngModelOptions]="{
                                            standalone: true
                                        }" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ item?.MaxHours }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- HoursWorked -->
                            <td class="disabled">
                                {{ item?.HoursWorked }}
                            </td>
                            <!-- ClassList -->
                            <td *ngIf="displayDetails && useClass">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-select styleClass="w-full" [ngClass]="{
                                            'ng-invalid': !item.ClassListID
                                        }" [ngModelOptions]="{
                                            standalone: true
                                        }" [autoDisplayFirst]="false" appendTo="body" [options]="authClasses"
                                            [(ngModel)]="item.ClassListID"></p-select>
                                    </ng-template>
                                    <ng-template pTemplate="output"></ng-template>
                                </p-cellEditor>
                                {{
                                (
                                authClasses
                                | itemlookup: 'value':item?.ClassListID
                                )?.label
                                }}
                            </td>
                            <!-- PremiumPayIndicator -->
                            <td *ngIf="displayDetails">
                                <p-cellEditor>
                                    <ng-template *ngIf="
                                        !item.IsReadOnly &&
                                        !item.PremiumPayIndicator
                                    " pTemplate="input">
                                        <p-checkbox binary="true" [(ngModel)]="
                                            item.PremiumPayIndicator
                                        " [ngModelOptions]="{
                                            standalone: true
                                        }"></p-checkbox>
                                    </ng-template>
                                    <ng-template *ngIf="
                                        item.IsReadOnly ||
                                        item.PremiumPayIndicator
                                    " pTemplate="input">
                                        <i [ngClass]="{
                                            pi: true,
                                            'pi-check':
                                                item?.PremiumPayIndicator,
                                            green: item?.PremiumPayIndicator
                                        }"></i>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <i [ngClass]="{
                                            pi: true,
                                            'pi-check':
                                                item?.PremiumPayIndicator,
                                            green: item?.PremiumPayIndicator
                                        }"></i>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- AuthDesc -->
                            <td *ngIf="displayDetails" [attr.title]="item.AuthDesc">
                                <p-cellEditor>
                                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                        <input title="Auth Desc" pInputText [(ngModel)]="item.AuthDesc"
                                            [ngModelOptions]="{
                                            standalone: true
                                        }" />
                                    </ng-template>
                                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                        {{ item?.AuthDesc }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <div *ngIf="isLink(item?.AuthDesc)">
                                            <a target="_blank" [href]="item?.AuthDesc">
                                                {{ item?.AuthDesc }}
                                            </a>
                                        </div>
                                        <div *ngIf="!isLink(item?.AuthDesc)">
                                            {{ item?.AuthDesc }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- Delete -->
                            <td class="delete-cell">
                                <button *ngIf="!item.IsReadOnly" title="Delete" pButton type="button"
                                    icon="pi pi-trash" class="p-button-danger p-button-rounded p-button-text"
                                    (click)="onDelete([item])"></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
